import React, { useState } from 'react';
import { Row, Col, Button, Card } from 'react-bootstrap';
import CsLineIcons from 'cs-line-icons/CsLineIcons';
import { useSelector } from 'react-redux';
// components
import EditUserBillingModal from './EditUserBillingModal';

const BillingData = ({ data, setUpdatePage }) => {
  // console.log('datos de facturacion:', data);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { currentUser } = useSelector((state) => state.auth);

  return (
    <>
      {/* Edit user Modal Start */}
      <EditUserBillingModal isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} data={data} setUpdatePage={setUpdatePage} />
      {/*  Edit user Modal End  */}
      <Card className="mb-5 pt-xl-3 sh-xl-60 position-relative">
        <Card.Body>
          <Row className="g-0">
            <Col xs="12" lg="7" xl="12" className="bg-successx d-flex flex-column justify-content-start">
              <div className="text-alternate mb-2">
                <CsLineIcons icon="credit-card" size="19" className="text-muted me-2" />
                CLABE
                <span className="ps-2 text-primary">{data.clabe}</span>
              </div>
              <div className="text-alternate mb-2 d-flex">
                <CsLineIcons icon="user" size="19" className="text-muted" />
                <div className="text-alternate ms-2">{data?.customer}</div>
              </div>
              <div className="text-alternate mb-2">
                <CsLineIcons icon="email" size="19" className="text-muted me-2" />
                {data?.billing_email}
              </div>
              <div className="text-alternate mb-2">
                <CsLineIcons icon="suitcase" size="19" className="text-muted me-2" />
                REGIMEN
                <span className="ps-2 text-primary">{data?.tax_system}</span>
              </div>
              <div className="text-alternate mb-2">
                <CsLineIcons icon="notification" size="19" className="text-muted me-2" />
                {data?.tax_system_value}
              </div>
              <div className="text-alternate mb-2">
                <CsLineIcons icon="shield" size="19" className="text-muted me-2" />
                RFC
                <span className="ps-2 text-primary">{data.tax_id}</span>
              </div>
            </Col>
            <Col xs="12" lg="5" xl="12" className="bg-warningx d-flex flex-column justify-content-start">
              <div className="text-alternate mb-2">
                <CsLineIcons icon="destination" size="19" className="text-muted me-2" />
                <span className={data?.street ? 'visible' : 'invisible'}>{`${data?.street} # ${data?.street_number}`}</span>
              </div>
              <div className="text-alternate mb-2">
                <CsLineIcons icon="pin" size="19" className="text-muted me-2" />
                <span className={data?.zip_code ? 'visible' : 'invisible'}> {`${data?.neighborhood} C.P. ${data?.zip_code}`}</span>
              </div>
              <div className="text-alternate mb-2">
                <CsLineIcons icon="building" size="19" className="text-muted me-2" />
                <span className={data?.city ? 'visible' : 'invisible'}> {`${data?.city}, ${data?.state}.`}</span>
              </div>
              <div className="text-alternate mb-2">
                <CsLineIcons icon="dollar" size="19" className="text-muted me-2" />
                SALDO AUTOMÁTICO
                <span className="ps-2 text-primary">{data?.automatic_balance ? 'SI' : 'NO'}</span>
              </div>
              <div className="text-alternate mb-2">
                <CsLineIcons icon="invoice" size="19" className="text-muted me-2" />
                COMPROBANTE AUTOMÁTICO
                <span className="ps-2 text-primary">{data?.automatic_invoice ? 'SI' : 'NO'}</span>
              </div>
            </Col>
            <div
              className={`d-flex justify-content-end align-items-end me-5 ${currentUser.access === 'Control Total' ? 'visible' : 'invisible'}`}
              style={{ position: 'absolute', bottom: '20px', right: '0px' }}
            >
              <Button
                variant="primary"
                className="btn-icon btn-icon-start w-auto "
                onClick={() => {
                  setIsModalOpen(true);
                }}
              >
                <CsLineIcons icon="edit" size="18" />
                <span> Editar </span>
              </Button>
            </div>
          </Row>
        </Card.Body>
      </Card>
    </>
  );
};

export default BillingData;
